import { useNavigate } from 'react-router';

/**
 * 404 fallback. Kept on `useNavigate` (not `useNav`) on purpose:
 * the `navigate(-1)` history-back call has no typed-route equivalent,
 * and "go back one step in history" is genuinely the right action
 * here — there's no destination to type-check.
 */
function PageNotFound() {
  const navigate = useNavigate();

  return (
    <div>
      <p>
        The page you are looking for could not be found{' '}
        <span role="img" aria-label="sad">
          😢
        </span>
      </p>
      <button onClick={() => navigate(-1)}>&larr; Go back</button>
    </div>
  );
}

export default PageNotFound;
